import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../../firebase'
import { titleFormatter } from '../../../helpers/titleFormatter';

function Posts() {

    const [posts, setPosts] = useState([])

    useEffect(() => {

        try {
            const postsRef = firestore.collection("football-blogs");
            postsRef.orderBy("date_iso", "desc").onSnapshot(({docs}) => {
                const posts = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setPosts(posts)
            })
        } catch (error) {
            
        }

    }, [])

    return (
        <div className="row my-4">
            {posts?.map((post, index) => {


                let dateFormatted, datePost
                datePost = new Date(post.date_iso)
                
                if (datePost) {
                    dateFormatted = `${datePost.getDate()}/${datePost.getMonth()+1}/${datePost.getFullYear()}`
                } else {
                    dateFormatted = new Date()
                }
                

                return (
                    <div className="col-md-6 col-lg-4 my-3" key={index}>
                        <div className="card">
                            <Link to={`/innlegg/single/${post.id}`}>
                                <img src={post.featured_image_post} alt={post.title} className="img-fluid" style={{objectFit: "cover", width: "500px", height: "300px"}} />
                            </Link>
                            <div className="card-body">
                                <Link to={`/innlegg/single/${post.id}`}>
                                    <h6 className="font-weight-bold">{titleFormatter(post.title)}</h6>
                                </Link>
                                <small className="text-muted">Av {post.author_name} den {dateFormatted}</small>
                            </div>

                        </div>
                    </div>
                )
            })}
        </div>

    )
}
export default Posts